export default __webpack_public_path__ + "fonts/95204d692a54e0ff6ecea0eeedc0fc1f.woff";